import { type ReactNode } from 'react';
import { useRecoilValue } from 'recoil';
import CompactToggle from '~/components/toolbar/shared/CompactToggle';
import { useSwitchLineMode } from '~/hooks/viewer/useSwitchLineMode';
import { lineOptionsState } from '~/state/atoms/toolsAtoms';

interface LineToolOptionsProps {
    /** Switches shown after the line's own. */
    children?: ReactNode;
}

export default function LineToolOptions({ children }: LineToolOptionsProps) {
    const lineOptions = useRecoilValue(lineOptionsState);
    const switchLineMode = useSwitchLineMode();

    return (
        <>
            <CompactToggle
                labelId="toolbar.contouring.erase"
                tooltipId="toolbar.contouring.erase.tooltip"
                value={lineOptions.mode === 'erase'}
                onChange={(erase) =>
                    switchLineMode(() => (erase ? 'erase' : 'draw'))
                }
            />
            {children}
        </>
    );
}
